import { render, staticRenderFns } from "./IconFbMeta.vue?vue&type=template&id=2df09bdd"
import script from "./IconFbMeta.vue?vue&type=script&lang=js"
export * from "./IconFbMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports